export default __webpack_public_path__ + "static/media/icon-x-black.6c1fe7ef.svg";